import { Link } from "react-router-dom";
import { MapPin, Phone, LockKeyhole } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const LOGO_URL = `${BACKEND_URL}/api/uploads/photos/elitethebarber-logo-transparent.png`;

export const Footer = () => {
  const { t, lang, toggleLang } = useLanguage();

  return (
    <footer data-testid="site-footer" className="bg-[#080808] border-t border-white/10 pt-16 pb-8 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <img
            src={LOGO_URL}
            alt="EliteTheBarber logo"
            className="h-24 w-auto mb-4"
          />
          <p className="text-white/50 text-sm leading-relaxed">{t("footer.tagline")}</p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">{t("footer.quickLinks")}</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" data-testid="footer-home-link" className="text-white/70 hover:text-gold">{t("nav.home")}</Link></li>
            <li><Link to="/diensten" data-testid="footer-services-link" className="text-white/70 hover:text-gold">{t("nav.services")}</Link></li>
            <li><Link to="/boeken" data-testid="footer-book-link" className="text-white/70 hover:text-gold">{t("nav.book")}</Link></li>
            <li><Link to="/afspraak-maken" data-testid="footer-afspraak-maken-link" className="text-white/70 hover:text-gold">{lang === "nl" ? "Afspraak maken" : "Book appointment"}</Link></li>
            <li><Link to="/kapper-utrecht" data-testid="footer-kapper-utrecht-link" className="text-white/70 hover:text-gold">{lang === "nl" ? "Kapper Utrecht" : "Barber Utrecht"}</Link></li>
            <li><Link to="/contact" data-testid="footer-contact-link" className="text-white/70 hover:text-gold">{t("nav.contact")}</Link></li>
            <li><Link to="/mijn-afspraak" data-testid="footer-manage-appointment-link" className="text-white/70 hover:text-gold">{t("footer.manageAppointment")}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">{t("footer.legal")}</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/privacybeleid" data-testid="footer-privacy-link" className="text-white/70 hover:text-gold">{t("footer.privacy")}</Link></li>
            <li><Link to="/cookiebeleid" data-testid="footer-cookies-link" className="text-white/70 hover:text-gold">{t("footer.cookies")}</Link></li>
            <li><Link to="/algemene-voorwaarden" data-testid="footer-terms-link" className="text-white/70 hover:text-gold">{t("footer.terms")}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">{t("contact.title")}</h4>
          <div className="space-y-2 text-sm text-white/70">
            <p className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 text-gold shrink-0" /> Vlampijpstraat 75g<br />3534 AR Utrecht</p>
            <a href="tel:0618885582" data-testid="footer-phone-link" className="flex items-center gap-2 hover:text-gold"><Phone size={16} className="text-gold" /> 06 18885582</a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-white/40">
        <p>&copy; {new Date().getFullYear()} EliteTheBarber. {t("footer.rights")}</p>
        <div className="flex items-center gap-6">
          <button data-testid="footer-lang-toggle" onClick={toggleLang} className="uppercase tracking-widest hover:text-gold">
            NL | EN — {lang.toUpperCase()}
          </button>
          <Link
            to="/admin/login"
            data-testid="footer-admin-login-link"
            className="flex items-center gap-1.5 uppercase tracking-widest text-white/40 hover:text-gold transition-colors"
          >
            <LockKeyhole size={13} />
            {t("footer.admin")}
          </Link>
        </div>
      </div>
    </footer>
  );
};
